import { render, staticRenderFns } from "./questionmark.vue?vue&type=template&id=41382284&scoped=true&lang=html&"
import script from "./questionmark.vue?vue&type=script&lang=js&"
export * from "./questionmark.vue?vue&type=script&lang=js&"
import style0 from "./questionmark.vue?vue&type=style&index=0&id=41382284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41382284",
  null
  
)

export default component.exports